import { useContext, useMemo } from 'react'
import Crop from '../../cropper'
import { UGEContext } from '../context'
import { aspectRatioFromCropType } from '../utilities/crop-type'
import { Overlay } from './style'

type Props = {
    className?: string
}

const UGECropOverlay = ({ className }: Props) => {
    const { crop, cropType, dimensions, setCrop } = useContext(UGEContext)

    const aspectRatio = useMemo(
        () => aspectRatioFromCropType(cropType, dimensions.width / dimensions.height),
        [cropType, dimensions]
    )

    return (
        <Overlay className={className}>
            <Crop
                aspectRatio={aspectRatio}
                crop={crop}
                height={dimensions.height}
                width={dimensions.width}
                showDimensions
                onChange={setCrop}
            />
        </Overlay>
    )
}

export default UGECropOverlay
